import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Table } from "reactstrap";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import { ToolTip } from "../../AbstractElements";
import { getPatientPrescription } from "../PharmacySales/SalesService";
import { useNavigate } from "react-router-dom";
import { usePharmacy } from "../../_helper/PharmacyProvider";

const fetchPrescriptions = () =>
	new Promise((resolve) => {
		setTimeout(() => {
			resolve([
				{
					_id: "01",
					patient: "John Doe",
					date: "2025-09-01",
					medicines:
						"Paracetamol, Ibuprofen, Cetirizine, Azithromycin, Vitamin D, Multivitamin",
				},
				{
					_id: "02",
					patient: "Jane Smith",
					date: "2025-09-02",
					medicines: "Amoxicillin, Metformin, Amlodipine",
				},
				{
					_id: "03",
					patient: "Jane Smith",
					date: "2025-09-02",
					medicines: "Amoxicillin, Metformin, Amlodipine",
				},
				{
					_id: "04",
					patient: "Jane Smith",
					date: "2025-09-02",
					medicines: "Amoxicillin, Metformin, Amlodipine",
				},
				{
					_id: "05",
					patient: "Jane Smith",
					date: "2025-09-02",
					medicines: "Amoxicillin, Metformin, Amlodipine",
				},
				{
					_id: "06",
					patient: "Jane Smith",
					date: "2025-09-02",
					medicines: "Amoxicillin, Metformin, Amlodipine",
				},
				{
					_id: "07",
					patient: "Jane Smith",
					date: "2025-09-02",
					medicines: "Amoxicillin, Metformin, Amlodipine",
				},
				{
					_id: "08",
					patient: "Jane Smith",
					date: "2025-09-02",
					medicines: "Amoxicillin, Metformin, Amlodipine",
				},
				{
					_id: "09",
					patient: "Jane Smith",
					date: "2025-09-02",
					medicines: "Amoxicillin, Metformin, Amlodipine",
				},
				{
					_id: "10",
					patient: "Jane Smith",
					date: "2025-09-02",
					medicines: "Amoxicillin, Metformin, Amlodipine",
				},
			]);
		}, 1000);
	});

const TopPrescriptions = () => {
	const { t } = useTranslation();
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	const { pharmacyPOS } = usePharmacy();
	const hospital_id = pharmacyPOS?.hospital_id || false;
	// const [viewTooltipOpen, setViewTooltipOpen] = useState(false);
	// const toggleViewTooltip = () => setViewTooltipOpen(!viewTooltipOpen);

	// Store tooltip open states per row (_id based)
	const [tooltipOpen, setTooltipOpen] = useState({});

	const toggleTooltip = (id) => {
		setTooltipOpen((prev) => ({
			...prev,
			[id]: !prev[id],
		}));
	};

	useEffect(() => {
		loadRecentPrescriptions()
	}, [hospital_id]);

	const loadRecentPrescriptions = async (patientId) => {
		const body = {
			patient_id: '',
			pageNo: 1,
			pageSize: 10,
			isHospitalPatient: true,
			clinic_id: hospital_id
		}
		try {
			// Replace with your actual API call to fetch prescriptions
			const response = await getPatientPrescription(body);
			const prescriptions = response.data.data || [];

			// Mock data for demonstration - replace with actual API response
			// const prescriptions = mockPrescriptions;
			setData(prescriptions); // Top 5
		} catch (error) {
			console.error("Error fetching recent prescriptions:", error);
			setData([]);
		} finally {
			setLoading(false);
		}
	};

	const formatDate = (dateString) => {
		if (!dateString) return "N/A";
		const date = new Date(dateString);
		const day = date.getDate().toString().padStart(2, '0');
		const month = date.toLocaleString(undefined, { month: 'short' });
		const year = date.getFullYear();
		return `${day} ${month} ${year}`; // Example: May 07, 2025
	};

	const handlePrescriptionClick = (prescription) => {
		// Navigate to NewSales with prescription data as state
		navigate(`${process.env.PUBLIC_URL}/new-sales`, { state: { prescriptionData: prescription } });
	};

	return (
		<Card>
			<CardHeader><h6 className="mb-0">{t("Recent Patient Prescriptions")}</h6></CardHeader>
			<CardBody>
				{loading ? (
					<Skeleton count={5} height={30} />
				) : data.length === 0 ? (
					<p className="text-center text-muted">{t("No prescriptions found")}</p>
				) : (
					// <div className="recent-table table-responsive currency-table">
					// <div className="table table-sm table-bordered">
					<div style={{ height: 250 }} className="tw-w-full tw-overflow-x-scroll tw-overflow-y-auto">
						<Table size="sm" striped bordered style={{ minWidth: 650 }}>
							<thead>
								<tr>
									<th style={{ whiteSpace: "nowrap" }}>{t("Patient Name")}</th>
									{/* <th style={{ whiteSpace: "nowrap" }}>{t("Consultation Date")}</th> */}
									<th style={{ whiteSpace: "nowrap" }}>{t("Prescribed Medicines")}</th>
									<th className="text-center" style={{ whiteSpace: "nowrap" }}>
										{t("Actions")}
									</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, idx) => (
									<>
										<tr key={item._id + idx}>
											<td style={{ whiteSpace: "nowrap" }}>{item.patientName || item.patient.name}</td>
											{/* <td style={{ whiteSpace: "nowrap" }}>{formatDate(item.createdAt)}</td> */}
											<td style={{ maxWidth: "300px" }}>
												<span
													className="d-inline-block text-truncate"
													style={{ maxWidth: "100%", whiteSpace: "nowrap" }}
													title={item.prescriptions.map(p => p.medication_name).join(", ")}
												>
													{item.prescriptions.map(p => p.medication_name).join(", ")}
												</span>
											</td>
											<td className="text-center">
												<button
													className="btn btn-link p-0 text-success small"
													id={`ViewToolTip-${item._id}`}
													onClick={() => handlePrescriptionClick(item)}
												>
													<i className="fa fa-plus" style={{ fontSize: "14px" }}></i>
													<ToolTip
														attrToolTip={{
															placement: "top",
															isOpen: tooltipOpen[item._id] || false,
															target: `ViewToolTip-${item._id}`,
															toggle: () => toggleTooltip(item._id),
														}}
													>
														<strong>{t("Add Sale")}</strong>
													</ToolTip>
												</button>
											</td>
										</tr>
									</>
								))}
							</tbody>
						</Table>
					</div>
				)}
			</CardBody>
		</Card>
	);
};

export default TopPrescriptions;
